import { Link } from '@mui/joy';
import { createLink } from '@tanstack/react-router';

export const RouterLink = createLink(Link);
